<template>
  <div class="wrapper .ccui-navigation">
    <base-bread-crumb :currBreadCrumb="currBreadCrumb"></base-bread-crumb>
    <div class="ccui-app-container">
      <div class="ccui-app-container-detail-body content">
        <div class="page-title">{{ $t("page.sup.title") }}</div>
        <el-divider></el-divider>
        <p class="section">
          {{ $t("page.sup.content1")
          }}<!--<a class="link-color fwb" :href="baseUrl" target="_blank">{{-->
          <!--baseUrl-->
          <!--}}-->
          <!--</a-->
          <!--&gt;-->{{ $t("page.sup.content2") }}
        </p>
        <p class="section">
          {{ $t("page.sup.content3")
          }}<span class="">{{ $t("page.sup.contentStrong") }}</span
          >{{ $t("page.sup.content4") }}
        </p>
        <!--<p class="section">-->
        <!--{{ $t("page.sup.content5") }}<span class="">Internet Explorer 8</span-->
        <!--&gt;-->
        <!--{{ $t("page.sup.content6")-->
        <!--}}<router-link-->
        <!--to="/question"-->
        <!--target="_blank"-->
        <!--class="link-color tdu"-->
        <!--&gt;{{ $t("page.sup.questions") }}</router-link-->
        <!--&gt;-->
        <!--</p>-->
        <p class="fwb other-desc">{{ $t("page.sup.explain") }}</p>

        <div class="linkBox">
          <router-link
            class="link"
            to="/infoManageNetworkAccess"
            target="_blank"
            >{{ $t("page.sup.explain1") }}</router-link
          >
        </div>
        <!--<div class="linkBox">-->
        <!--&lt;!&ndash;          <a class="link" :href="sraUrl + '/maReady01'" target="_blank">{{&ndash;&gt;-->
        <!--&lt;!&ndash;            $t("page.sup.explain2")&ndash;&gt;-->
        <!--&lt;!&ndash;          }}</a>&ndash;&gt;-->
        <!--<a href="javascript:;">{{ $t("page.sup.explain2") }}</a>-->
        <!--</div>-->
        <!--<div class="linkBox">-->
        <!--<a :href="baseUrl + '/question'" target="_blank" class="link">{{-->
        <!--$t("page.sup.explain3")-->
        <!--}}</a>-->
        <!--</div>-->
        <div class="linkBox">
          <a
            :href="baseUrl + '/operationHandbook?id=139'"
            class="link"
            target="_blank"
            >{{ $t("page.sup.explain4") }}</a
          >
        </div>
        <!--<div class="linkBox">-->
        <!--<a-->
        <!--:href="baseUrl + '/operationHandbook?id=139&faqId=430'"-->
        <!--class="link"-->
        <!--target="_blank"-->
        <!--&gt;{{ $t("page.sup.explain5") }}</a-->
        <!--&gt;-->
        <!--</div>-->
        <!--<div class="linkBox">-->
        <!--<router-link-->
        <!--to="/infoManageQuestionDeil"-->
        <!--class="link"-->
        <!--target="_blank"-->
        <!--&gt;{{ $t("page.sup.explain6") }}</router-link-->
        <!--&gt;-->
        <!--</div>-->
      </div>
    </div>
  </div>
</template>

<script>
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
export default {
  name: "operationManual",
  components: {
    baseBreadCrumb
  },
  data() {
    return {
      baseUrl: this.$addUrlPerFix(process.env.VUE_APP_BASE_URL),
      sraUrl: this.$addUrlPerFix(process.env.VUE_APP_SRA_URL),
      url: "",
      currBreadCrumb: [
        { title: this.$t("page.content.supplierOperationGuide") }
      ]
    };
  },

  methods: {
    // password(id) {
    //   this.$router.push({
    //     path: "/infoMaintain/infoManageQuestionDeil",
    //     query: {
    //       faqId: id
    //     }
    //   });
    // }
  }
};
</script>

<style scoped lang="scss">
.ccui-app-container-detail {
  min-height: calc(100vh - 190px);
  margin: 0px auto 0px !important;
  padding: 15px 0 15px;
  min-width: 1180px;
}
</style>
